let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4kFs8")).then(() => parcelRequire('3T3Pt'));